import {
  Button,
  Flex,
  Overlay,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import { isClientOutdatedAtom } from "~/atoms";

/**
 * Must outrank every other layer in the app (highest in use is 2001). Once the
 * server refuses this bundle, the requests behind it never settle, so page
 * loaders keep spinning underneath — a notice that shares the stack with them
 * renders behind a spinner.
 */
const OUTDATED_CLIENT_Z_INDEX = 3000;

/**
 * Shown only when a reload has already failed to bring the tab up to date.
 * Covers the whole viewport rather than sitting over the page: every request
 * from here on is refused, so what is underneath is frozen mid-load and the
 * only way forward is a refresh. Offers no dismiss for the same reason.
 */
const OutdatedClientNotice = () => {
  const { t } = useTranslation();
  const isClientOutdated = useAtomValue(isClientOutdatedAtom);

  if (!isClientOutdated) return null;

  return (
    <Overlay
      fixed
      zIndex={OUTDATED_CLIENT_Z_INDEX}
      backgroundOpacity={0.65}
      blur={3}
    >
      <Flex align="center" justify="center" h="100%" p="md">
        <Paper p="xl" radius="md" shadow="lg" maw={420} w="100%">
          <Stack gap="md">
            <Title order={4}>{t("outdatedClient.title")}</Title>
            <Text size="sm">{t("outdatedClient.message")}</Text>
            <Button fullWidth onClick={() => window.location.reload()}>
              {t("outdatedClient.action")}
            </Button>
          </Stack>
        </Paper>
      </Flex>
    </Overlay>
  );
};

export default OutdatedClientNotice;
